export default __webpack_public_path__ + "static/media/Couch.83ede250.png";